<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/iGFyAP/tc-custom/9781460363829.jpg?1701889973906" alt="This image is the cover for the book Deadline"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Deadline
      </h1>
      <p class="bookDescription body article font2">
        <p>Washington television reporter Tess Abbott is the best in the business, always getting the story <i>and</i> the truth. When the race for governor heats up in her home state of Mississippi, Tess jumps at the chance to cover it.<br/><br/>Among the dozens of media competing for an "exclusive," Tess meets newspaper reporter Spencer Reed, who is about to uncover the biggest political scandal of his career. Despite the rivalry and the adrenaline, focusing on the race becomes difficult for Tess when she receives an anonymous phone call from prisona call that leaves her reeling.<br/><br/>The unsettling message stirs her memory, bringing back childhood nightmaresnightmares of murder. When a local man turns up deadwith personal information about Tess in his possessionthe two journalists quickly realize there is a sinister connection between Tess's past and the election. As the pieces of the puzzle fall into place Tess's safety is compromised, and she and Spencer must find a killer primed to finish a job he started so long ago.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Metsy Hingle
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7adc0095